import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import CardList from "./newUx/CardList/CardList";

const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];

export default function Services() {
  const navigate = useNavigate();
  const localData = useSelector((state) => state?.localStorage)
  const { micrositeID, tabConfigId } = localData
  const [loading, setLoading] = useState(true);
  const [activeKey,] = useState("service");
  const [responseData, setResponseData] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const id = micrositeID;

  const getServicesData = async (activeKey, id) => {
    try {
      setLoading(true);
      if (id) {
        const response = await getRequest(
          userapiservice.getMicrositeDetailsTabs(id, tabConfigId)
        );
        setResponseData(response);
        // console.log("response data", response)
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)
    }
    finally {
      setLoading(false);
    }
  };

  const PlayVideoHandler = (url, mediaType) => {
    setMediaType(mediaType)
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf('youtu.be') !== -1) {
      const video_id = shortUrl?.split('youtu.be/')[1].split('?')[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  }

  const onCardClickHandler = (data) => {
    navigate(`/microsite/${data.id}/micrositeDetails`, {
      state: { page: activeKey, data: data },
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  useEffect(() => {
    getServicesData(activeKey, id);
  }, [activeKey, id]);

  if (loading) {
    return (
      <div
        className="ant-tabs-content-holder"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="loader">
          <Spin tip="Loading" size="large" />
        </div>
      </div>
    )
  } else {
    return (
      <CardList
        responseData={responseData}
        color={color}
        PlayVideoHandler={PlayVideoHandler}
        convertToStandardURL={convertToStandardURL}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        videoUrl={videoUrl}
        mediaType={mediaType}
        onCardClickHandler={onCardClickHandler}
      />
    );
  }
}
